<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
// import getParams from "@/utils/getQuery";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    // getParams();

    // //   获取参数statistics  info=ewoiZGV2aWNlSWQiOiI1NzFkMWJmNDI2ZGRjZWVjMTQwMDQyOTk2OGE0ZTY3NCIsCiJNQUFTUC1UT0tFTiI6IiIsCiJ1c2VySWQiOiIiLAoiY2hhbm5lbElkIjoiMTIiCn0
    // let info = this.getQuery("info");
    // // alert("获取到的info是" + info);
    // if (info !== null) {
    //   info = decodeURIComponent(info);
    //   info = JSON.parse(Base64.decode(info));
    //   sessionStorage.setItem("token", info["MAASP-TOKEN"]);
    //   sessionStorage.setItem("deviceId", info.deviceId);
    //   sessionStorage.setItem("userId", info.userId);
    // } else {
    //   this.$toast.fail("获取用户信息失败!");
    //   return false;
    // }
  },
  methods: {
    // getQuery(param) {
    //   var currentUrl = window.location.href; //获取当前链接
    //   var arr = currentUrl.split("?"); //分割域名和参数界限
    //   if (arr.length > 1) {
    //     arr = arr[1].split("&"); //分割参数
    //     for (var i = 0; i < arr.length; i++) {
    //       var tem = arr[i].split("="); //分割参数名和参数内容
    //       if (tem[0] == param) {
    //         return tem[1];
    //       }
    //     }
    //     return null;
    //   } else {
    //     return null;
    //   }
    // },
  },
};
</script>
<style lang="scss">
</style>
